import React, { useEffect, useState } from 'react';
import ViewStudentTransferDetail from './ViewStudentTransferDetail';
import ProgressAndActionsWrapper from './ProgressAndActionsWrapper';
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper';
import { ReactComponent as BackIcon } from "../../assets/img/svg/BackArrow.svg"
import { useLocation } from "react-router";
import { getTransferDetails } from './utils';
import ALoader from 'views/pages/manage/common/a-loader';
const ViewDetailsWrapper = () => {
    const [details, setDetails] = useState({})
    const [loader, setLoader] = useState(false)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const psid = queryParams.get("psid");
    const requestId = queryParams.get("requestId");
    const studentName = queryParams.get("studentName");
    const applicationId = queryParams.get("applicationId");
    const isBmApproval = queryParams.get("isBmApproval");

    const getDetails= async ()=>{
       setLoader(true);
       const res= await getTransferDetails(psid,requestId,applicationId)
       setDetails(res)
       setLoader(false)
    }
    useEffect(()=>{
        getDetails()
    },[])


    return (
        <>
            {loader&& <ALoader position='fixed'/>}
                <div className="large-text mx-5 my-4 label-color">
                    <IconButtonWrapper onClick={() => window.close()}>
                        <BackIcon />
                    </IconButtonWrapper>
                     {`${studentName} (${psid})`}
                </div>
                <div className="mx-5 d-flex justify-space-between">
                    <div style={{ width: "65%" }}>
                        <ViewStudentTransferDetail details={details} />
                    </div>
                     <div className="flex-grow-1">
                    <ProgressAndActionsWrapper psid={psid} details={details} isBmApproval={isBmApproval} setLoader={setLoader} applicationId={applicationId} id={requestId}/>
                    </div>
                </div>

        </>
    )
}
export default ViewDetailsWrapper